export default "__VITE_ASSET__Dle1y6Wh__"